document.addEventListener("DOMContentLoaded", function () {
  // ========================================
  // MOBILE MENU TOGGLE
  // ========================================
  const toggleBtn = document.querySelector(".mobile-toggle-cta");
  const mainMenu = document.querySelector(".main-menu");
  const logo = document.querySelector(".navbar .logo");
  const menuLinks = document.querySelectorAll(".main-menu a");
  const body = document.body;

  // Breakpoint lg (doit correspondre à $bm__lg dans SCSS)
  const BP_LG = 992;

  function openMenu() {
    toggleBtn.classList.add("-open");
    mainMenu.classList.add("-open");
    body.classList.add("menu-open");
    if (logo) logo.classList.add("-menu-open");
  }

  function closeMenu() {
    toggleBtn.classList.remove("-open");
    mainMenu.classList.remove("-open");
    body.classList.remove("menu-open");
    if (logo) logo.classList.remove("-menu-open");
    closeDropdowns();
  }

  function toggleMenu() {
    if (mainMenu.classList.contains("-open")) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  // Toggle au clic sur le burger
  if (toggleBtn) {
    toggleBtn.addEventListener("click", toggleMenu);
  }

  // Fermer le menu au clic sur un lien (sauf les parents de sous-menu)
  menuLinks.forEach((link) => {
    link.addEventListener("click", () => {
      const li = link.parentElement;
      const isDropdownParent =
        li.classList.contains("dropdown") ||
        li.classList.contains("link-opener");
      if (window.innerWidth < BP_LG && !isDropdownParent) {
        closeMenu();
      }
    });
  });

  // Fermer le menu avec la touche Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mainMenu.classList.contains("-open")) {
      closeMenu();
    }
  });

  // Fermer le menu si on redimensionne au-dessus du breakpoint
  window.addEventListener("resize", () => {
    if (window.innerWidth >= BP_LG) {
      closeMenu();
    }
  });

  // ========================================
  // DROPDOWN SUBMENUS (desktop popup)
  // ========================================
  const dropdowns = document.querySelectorAll(
    ".main-menu li.dropdown, .main-menu li.link-opener"
  );

  function closeDropdowns(except = null) {
    dropdowns.forEach((li) => {
      if (li !== except) {
        li.classList.remove("-open");
      }
    });
  }

  dropdowns.forEach((li) => {
    const parentLink = li.querySelector(":scope > a");
    if (!parentLink) return;

    parentLink.addEventListener("click", (e) => {
      // Mobile: tap toggles the submenu accordion
      // (stopImmediatePropagation also blocks the smooth-scroll handler)
      if (window.innerWidth < BP_LG) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeDropdowns(li);
        li.classList.toggle("-open");
        return;
      }

      // Touch devices at desktop width: first tap opens the popup,
      // second tap follows the link (hover handles it elsewhere)
      const touchOnly = window.matchMedia("(hover: none)").matches;
      if (touchOnly && !li.classList.contains("-open")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeDropdowns(li);
        li.classList.add("-open");
      }
    });
  });

  // Close popups on outside click or Escape
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".main-menu li.dropdown, .main-menu li.link-opener")) {
      closeDropdowns();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeDropdowns();
    }
  });

  // ========================================
  // FIXED NAVIGATION BAR ON SCROLL
  // ========================================
  const siteNav = document.getElementById("site-nav");
  const navHeight = siteNav ? siteNav.offsetHeight : 0;

  if (siteNav && window.innerWidth >= BP_LG) {
    window.addEventListener("scroll", () => {
      if (window.scrollY >= navHeight) {
        siteNav.classList.add("has_bg");
      } else if (window.scrollY === 0) {
        siteNav.classList.remove("has_bg");
      }
    });
  }
});
